
<template>
  <div class="change-account">
    <div class="commonBg"></div>
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon name="arrow-left" @click="back" />
        <div class="details_top_title">绑定手机号</div>
        <span></span>
        <!-- <van-icon name="close" /> -->
      </div>
    </div>
    <div class="container">
      <div class="change-login" v-if="pageIndex == 0">
        <span class="tip">请输入手机号</span>
        <div class="input-box input-box1">
          <i class="phone-num">+86</i>
          <input
            type="text"
            maxlength="11"
            v-model="form.account"
            placeholder="输入手机号"
          />
        </div>
        <div class="input-box input-box2">
          <input type="text" placeholder="输入验证码" v-model="code" />
          <span
            class="container-span"
            style="cursor: pointer"
            @click="sendMessage"
            v-if="waitTime == 0"
            >获取验证码</span
          >
          <span style="color: #ccc" v-else>{{ waitTime }}s后重新获取</span>
        </div>
        <i class="login-btn" @click="login">确定</i>
      </div>
      <div class="choose-account" v-if="pageIndex == 1">
        <span class="tip1">检测到手机号已关联社区账号 </span>
        <div class="current-account">
          <img class="avatar" :src="accountArr[1].avatar" />
          <span class="name">{{ accountArr[1].nickName }}</span>
        </div>
        <span class="tip2">是否同时绑定当前登录社区账号</span>
        <span class="tip3"
          >提示：绑定后，手机号已关联的社区账号不会注销，手机号将同时绑定两个社区账号。</span
        >
        <div class="account-box">
          <!-- <i class="select-on" v-if="currentAcc.memberId == item.memberId"></i> -->
          <img class="avatar" :src="accountArr[0].avatar" />
          <div class="info">
            <span class="name">{{ accountArr[0].nickName }}</span>
            <span class="info-text info1">{{ accountArr[0].remark }}</span>
            <!-- <span class="info-text info2">dasda</span> -->
          </div>
          <i class="current-icon"></i>
        </div>
        <i class="change-btn" @click="changePop">绑定</i>
        <i class="no-change" @click="back">暂不绑定</i>
      </div>
      <div class="change-success" v-if="pageIndex == 2">
        <span class="tip1" v-if="this.accountArr.length == 1"
          >已经成功将手机号绑定至&nbsp;{{ currentAcc.nickName }}&nbsp;社区账号
        </span>
        <span class="tip1" v-else
          >绑定成功，手机号已绑定&nbsp;{{ currentAcc.nickName }}&nbsp;社区账号
        </span>
        <div class="account-box">
          <img class="avatar" :src="currentAcc.avatar" />
          <div class="info">
            <span class="name">{{ currentAcc.nickName }}</span>
            <span class="info-text info1">{{ currentAcc.remark }}</span>
          </div>
        </div>
        <i class="return-btn" @click="closeChangeBind">返回</i>
      </div>
      <div class="no-account" v-if="pageIndex == 3">
        <i class="no-icon"></i>
        <span class="tip1">未检测到手机号关联的社区账号 </span>
        <span class="tip2">是否要绑定至当前登录社区账号 </span>
        <div class="account-box">
          <i class="current-icon"></i>
          <img class="avatar" :src="accountArr[0].avatar" />
          <div class="info">
            <span class="name">{{ accountArr[0].nickName }}</span>
            <span class="info-text info1">{{ accountArr[0].remark }}</span>
          </div>
        </div>
        <i class="change-btn" @click="bindPhone(1)">绑定</i>
        <i class="no-change" @click="back">暂不绑定</i>
      </div>
      <div class="pop" v-if="popShow">
        <div class="change-confirm">
          <span class="title">请确认绑定</span>
          <!-- <span
            >将账号绑定至{{ currentAcc.nickName }}账号后，社区账号{{
              currentAcc.memberId == accountArr[0].memberId
                ? accountArr[1].nickName
                : accountArr[0].nickName
            }}将无法登录。社区账号互相绑定不影响游戏账号。请输入“我确认不再需要登录此社区账号”进行换绑。
          </span> -->
          <span
            >将手机号同时绑定至&nbsp;{{
              currentAcc.nickName
            }}&nbsp;账号后，在社区网页端/微信小程序端使用该手机号登录，可选择任一社区账号进入社区，请输入“确认绑定”进行绑定。
          </span>
          <input type="text" v-model="confirmText" placeholder="确认绑定" />
          <div class="btn-box">
            <i @click="popShow = false">取消</i>
            <i @click="changeBind">确认</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import * as _code from '../../../../../src/utils/code';
import { Toast } from 'vant';
import get from '@/api/get';
import qs from 'qs';
export default {
  components: {},
  data() {
    return {
      waitTime: '',
      code: '',
      form: {
        action: 'page',
        method: 'send',
        isMobileLogin: 1,
        account: '',
        sign: '',
        annex: ''
      },
      confirmText: '',
      popShow: false,
      currentAcc: {},
      pageIndex: 0,
      bindNum: '',
      accountArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    bindPhone(type) {
      let params;
      if (type == 1) {
        //单个绑定
        params = {
          phone: this.accountArr[0].phone,
          memberId: this.accountArr[0].memberId,
          secdat: this.accountArr[0].secdat
        };
        this.currentAcc = this.accountArr[0];
      } else {
        //两个选择
        //目前改为了两个帐号也只展示一个，在数据返回时已进行默认选择处理
        params = {
          phone: this.currentAcc.phone,
          memberId: this.currentAcc.memberId,
          secdat: this.currentAcc.secdat
        };
      }
      get.bindPhone(qs.stringify(params)).then((res) => {
        if (res.data.message == 'success') {
          this.pageIndex = 2;
          this.popShow = false;
          //换token
          let objToken = JSON.parse(sessionStorage.getItem('userObj')) || {}; //此处存在获取为空，会阻断代码运行
          objToken.token = res.data.data[0].token;
          sessionStorage.setItem('userObj', JSON.stringify(objToken));
          this.$store.commit(
            'setUserInfo',
            JSON.parse(sessionStorage.getItem('userObj'))
          );
          let cook_auth = `_pd_auth_${
            this.$store.state.gameAppkeyArr[this.$store.state.gameType]
          }`;
          this.$store.commit('changeToken', Cookies.get(cook_auth));
          this.$store.commit('changeBindPhoneShow', false);
          localStorage.setItem('bindIconShow', false);
        }
      });
    },
    login() {
      let phoneReg = /^1[3-9]\d{9}$/;
      if (phoneReg.test(this.form.account)) {
        if (this.code != '') {
          let params = {
            // appkey: window.user.appkey,
            appkey:
              this.$store.state.gameType == 2
                ? '1705460260139'
                : window.user.appkey,
            device: this.$store.state.isPad
              ? `snsweb${this.getRamNumber()}`
              : `snswechat${this.getRamNumber()}`,
            code: this.code,
            account: this.form.account,
            action: 'access',
            channel: '2010011001',
            ecid: '3010081001',
            version: 'v2',
            tag: 1
          };
          get.phoneLogin(params).then((res) => {
            if (res.data.status == 1) {
              let info = res.data.data;
              console.log(info);
              let params = {
                token: info.token,
                userId: info.userid,
                device: this.$store.state.isPad
                  ? `snsweb${this.getRamNumber()}`
                  : `snswechat${this.getRamNumber()}`
              };
              get.bindPhoneQuery(qs.stringify(params)).then((res) => {
                // if (res.data.code == 2052) {
                //   Toast('该手机号已被绑定过');
                // }
                if (res.data.code != 0) {
                  this.errorMessage(res.data);
                } else if (res.data.data.length == 2) {
                  if (res.data.data[0].current == 1) {
                    //判断当前登录帐号
                    //accountArr[0]为当前登录帐号、accountArr[1]为手机号关联账号
                    this.$set(this.accountArr, 0, res.data.data[0]);
                    this.$set(this.accountArr, 1, res.data.data[1]);
                  } else {
                    this.$set(this.accountArr, 0, res.data.data[1]);
                    this.$set(this.accountArr, 1, res.data.data[0]);
                  }
                  this.currentAcc = this.accountArr[0]; //取消了选择，需要默认选择
                  // this.$set(this.accountArr, 0, res.data.data[0]);
                  // this.$set(this.accountArr, 1, res.data.data[1]);
                  this.pageIndex = 1;
                } else {
                  this.$set(this.accountArr, 0, res.data.data[0]);
                  this.pageIndex = 3;
                }
              });
            } else {
              Toast('验证码错误');
            }
          });
        } else {
          Toast('请输入验证码');
        }
      } else {
        Toast('手机号格式不正确');
      }
    },
    getRamNumber() {
      var result = '';
      for (var i = 0; i < 40; i++) {
        result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
      }
      return result;
    },
    sendMessage() {
      let phoneReg = /^1[3-9]\d{9}$/;
      if (phoneReg.test(this.form.account)) {
        this.form.sign = this.$md5(
          this.$md5(this.form.account + 'ACED000574') + 'ACED000574'
        );
        this.waitTime = 60;
        let timer1 = setInterval(() => {
          this.waitTime--;
          if (this.waitTime == 0) {
            clearInterval(timer1);
          }
        }, 1000);
        let c = penc.ps(this.form);
        // c.h.appkey = window.user.appkey;
        (c.h.appkey =
          this.$store.state.gameType == 2
            ? '1705460260139'
            : window.user.appkey),
          get.sendCode({ d: c.d }, c.h).then((res) => {
            let b = {
              'zl-ret-nonce': res.headers['zl-ret-nonce'],
              'zl-ret-sign': res.headers['zl-ret-sign'],
              getResponseHeader: function (a) {
                return b[a];
              }
            };
            let dataInfo = penc.de(
              res.data.ret,
              b,
              res.config.headers['zl-p-nonce']
            );
            console.log(dataInfo);
            if (dataInfo.status == 1) {
              //发送成功
            }
          });
      } else {
        Toast('请输入正确的手机号');
      }
    },
    closeChangeBind() {
      this.$router.push({ name: 'homePage' });
      setTimeout(() => {
        location.reload(); //刷新token信息
      }, 100);
    },
    changeBind() {
      if (this.confirmText == '确认绑定') {
        this.bindPhone(2);
      } else {
        Toast('请输入正确验证文案');
      }
    },
    changePop() {
      if (this.currentAcc.memberId) {
        this.popShow = true;
      } else {
        Toast('请选择一个账号');
      }
    },
    // chooseAcc(item) {
    //   this.currentAcc = item;
    // },
    bindQuery() {
      if (this.bindNum != '') {
        get
          .bindCodeQuery(qs.stringify({ bindCode: this.bindNum }))
          .then((res) => {
            console.log(res.data);
            // if (res.data.code == 2055) {
            //   Toast('绑定码错误');
            // } else if (res.data.code == 2056) {
            //   Toast('绑定码已被绑定');
            // }
            if (res.data.code != 0) {
              this.errorMessage(res.data);
            } else {
              this.$set(this.accountArr, 0, res.data.data[0]);
              this.$set(this.accountArr, 1, res.data.data[1]);
              this.pageIndex = 1;
            }
          });
      } else {
        Toast('请输入绑定码');
      }
    },
    back() {
      this.$emit('changePage', 0);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='scss' scoped>
.change-account {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .container {
    i {
      display: block;
      font-style: normal;
    }

    margin-top: 1.5rem;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0 0.6rem;
    box-sizing: border-box;

    .change-login {
      width: 100%;

      .tip {
        display: inline-block;
        width: 100%;
        margin: 0.4rem 0;
      }

      span {
        color: #000000;
        font-size: 0.24rem;
      }

      .input-box {
        width: 6.29rem;
        height: 0.72rem;
        border: 0.01rem solid #969696;
        display: flex;
        align-items: center;

        .phone-num {
          width: 0.9rem;
          height: 0.4rem;
          border-right: 0.01rem solid #969696;
          color: #1a1a1a;
          font-size: 0.28rem;
          font-style: normal;
          text-align: center;
          line-height: 0.4rem;
          margin-right: 0.2rem;
        }

        input {
          font-size: 0.28rem;
          width: 100%;
          height: 0.4rem;
          border: none;
          outline: none;
        }

        *::-webkit-input-placeholder {
          color: #cccccc;
        }

        *:-moz-placeholder {
          /* FF 4-18 */
          color: #cccccc;
        }

        *::-moz-placeholder {
          /* FF 19+ */
          color: #cccccc;
        }

        *:-ms-input-placeholder {
          /* IE 10+ */
          color: #cccccc;
        }
      }

      .input-box2 {
        margin-top: 0.29rem;
        margin-bottom: 0.4rem;
      }

      .input-box2 input {
        margin-left: 0.2rem;
      }

      .input-box2 span {
        font-size: 0.22rem;
        margin-right: 0.21rem;
        white-space: nowrap;
      }

      .login-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        cursor: pointer;
      }
    }

    .choose-account {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 0.24rem;
        color: #000;
      }

      .tip1 {
        margin-top: 0.58rem;
        margin-bottom: 0.25rem;
      }

      .current-account {
        width: 4.06rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        box-shadow: 0rem 0.08rem 0.13rem 0rem rgba(34, 49, 60, 0.07);
        display: flex;
        align-items: center;

        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }
      }

      .tip2 {
        margin-top: 0.99rem;
      }
      .tip3 {
        width: 5.74rem;
        text-align: center;
        font-size: 0.18rem;
        color: #969696;
        margin-bottom: 0.34rem;
      }
      .account-box-on {
        border: 1px solid #23303b;
      }

      .account-box:nth-child(4) {
        margin-bottom: 0.32rem;
      }

      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;

        .current-icon {
          width: 0.67rem;
          height: 0.22rem;
          background: url('../../../../assets/img/gl/current-account.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          right: 0;
        }

        .select-on {
          width: 0.24rem;
          height: 0.24rem;
          background: url('../../../../assets/img/gl/select-on.png');
          background-size: 100% 100%;
          // transform: translateX(-0.54rem);
          position: absolute;
          left: -0.54rem;
        }

        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }

        .info {
          display: flex;
          flex-direction: column;

          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }

      .change-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 1rem;
        margin-bottom: 0.4rem;
      }

      .no-change {
        width: 6.29rem;
        height: 0.72rem;
        background: #f5f5f5;
        color: #898989;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
      }
    }

    .change-success {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tip1 {
        margin-top: 0.6rem;
        margin-bottom: 0.4rem;
      }

      span {
        font-size: 0.22rem;
        color: #000;
      }

      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;

        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }

        .info {
          display: flex;
          flex-direction: column;

          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }

      .return-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 0.5rem;
      }
    }

    .no-account {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tip1 {
        font-size: 0.24rem;
        color: #000;
      }

      .tip2 {
        font-size: 0.22rem;
        color: #000;
        margin-top: 1.54rem;
        margin-bottom: 0.3rem;
      }

      .no-icon {
        width: 0.9rem;
        height: 0.9rem;
        background: url('../../../../assets/img/gl/no-account.png');
        background-size: 100% 100%;
        margin-top: 1.19rem;
        margin-bottom: 0.54rem;
      }

      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;

        .current-icon {
          width: 0.67rem;
          height: 0.22rem;
          background: url('../../../../assets/img/gl/current-account.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          right: 0;
        }

        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }

        .info {
          display: flex;
          flex-direction: column;

          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }

      .change-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 0.51rem;
        margin-bottom: 0.4rem;
      }

      .no-change {
        width: 6.29rem;
        height: 0.72rem;
        background: #f5f5f5;
        color: #898989;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
      }
    }

    .pop {
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      display: flex;
      justify-content: center;
      align-items: center;

      .change-confirm {
        width: 5rem;
        height: 4.15rem;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 0.35rem;
        box-sizing: border-box;
        position: relative;

        .title {
          color: #2b2b2b;
          font-size: 0.3rem;
          font-weight: 500;
          margin-top: 0.3rem;
          margin-bottom: 0.16rem;
        }

        span {
          color: #1a1a1a;
          font-size: 0.22rem;
        }

        input {
          margin-top: 0.2rem;
          width: 4.38rem;
          height: 0.72rem;
          font-size: 0.24rem;
          outline: none;
          border: 0.01rem solid #b3b3b3;
          padding-left: 0.1rem;
          box-sizing: border-box;
        }

        *::-webkit-input-placeholder {
          color: #cccccc;
        }

        *:-moz-placeholder {
          /* FF 4-18 */
          color: #cccccc;
        }

        *::-moz-placeholder {
          /* FF 19+ */
          color: #cccccc;
        }

        *:-ms-input-placeholder {
          /* IE 10+ */
          color: #cccccc;
        }

        .btn-box {
          width: 100%;
          height: 0.76rem;
          position: absolute;
          bottom: 0;
          border-top: 0.01rem solid #b3b3b3;
          display: flex;

          i {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          i:nth-child(1) {
            border-right: 0.01rem solid #b3b3b3;
          }

          i:active {
            background-color: #cccccc;
          }
        }
      }
    }
  }
}
</style>